<template>
  <b-card>
    <div class="d-flex justify-content-between flex-wrap mb-2">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
    </div>
    <data-table :fields="fields" :items="transactions" :loading="loading">
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #user="{ data }">
        {{ data.item.user.first_name + " " + data.item.user.last_name }}
      </template>
      <template #payed_at="{ data }">
        {{ calcDate(data.item.payed_at) || "-" }}
      </template>
      <template #amount="{ data }">
        <small class="text-success"
          >{{ numberWithCommas(data.item.amount) }} تومان</small
        >
      </template>
      <template #refrence_code="{ data }">
        {{ data.item.refrence_code || "-" }}
      </template>
      <template #gateway_type="{ data }">
        {{ data.item.gateway_type == "zarinpal" ? "زرین پال" : "-" }}
      </template>

      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'success'
              : data.item.status == 2
              ? 'danger'
              : 'warning'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "پرداخت شده"
              : data.item.status == 2
              ? "لغو شده"
              : "رد شده"
          }}
        </b-badge>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormInput,
  BForm,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormInput,
    BForm,
    BFormGroup,
  },

  data() {
    return {
      choosenPage: 1,

      transactions: [],
      search: "",
      loading: false,
      url: "/panel/transactions",
      currentPage: 1,
      pagination: {},
      visible: false,
      loader: false,
      fields: [
        { key: "id", label: "شناسه" },
        { key: "user", label: "نام کاربر" },
        { key: "amount", label: "مبلغ" },
        { key: "refrence_code", label: "کد پیگیری" },
        { key: "gateway_type", label: "درگاه" },
        { key: "payed_at", label: "تاریخ پرداخت" },
        { key: "status", label: "وضعیت" },
      ],
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.getTransactions();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "transactions",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "transactions",
        });
      }
    },
  },
  created() {
    if (this.$route.query.key) {
      this.$router.push({
        name: "transactions",
      });
    }
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "transactions",
          query: {
            key: this.search,
          },
        });
      }
    },
    async getTransactions() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["exercise", "user", "course", "session"],
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.transactions = data.data.transactions;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
